// Reine Logik der Karte „Themen für Postfächer" (Kundenfeedback Autohaus
// Zwerger, 14.10.2026: „Wir werden gerade geflutet") – ohne Vue, damit sie
// mit Vitest prüfbar ist. Die Themen und ihre Bezeichnungen liefert das
// Backend (digest.Topics), dieselben wie im Profil unter „Benachrichtigungen".

export interface MailboxTopic {
  topic: string
  label: string
  enabled: boolean
}

export interface MailboxTopicSettings {
  topics: MailboxTopic[]
  /** Darf die Sitzung speichern? Nur Anzeige – das Backend prüft erneut. */
  canEdit: boolean
}

/** Macht die Antwort von GET …/mailbox-topics robust nutzbar. */
export function normalizeMailboxTopics (data: unknown): MailboxTopicSettings {
  const raw = (data ?? {}) as { topics?: unknown, canEdit?: unknown }
  const list = Array.isArray(raw.topics) ? raw.topics : []
  const topics = list
    .filter((t): t is Record<string, unknown> => !!t && typeof t === 'object' && typeof (t as { topic?: unknown }).topic === 'string')
    .map(t => ({
      topic: String(t.topic),
      label: typeof t.label === 'string' && t.label ? t.label : String(t.topic),
      enabled: t.enabled === true,
    }))
  return { topics, canEdit: !!raw.canEdit }
}

/** Liefert eine neue Liste, in der das Thema an- bzw. abgewählt ist. */
export function toggleMailboxTopic (topics: MailboxTopic[], key: string, enabled: boolean): MailboxTopic[] {
  return topics.map(t => (t.topic === key ? { ...t, enabled } : t))
}

/** Kurzfassung für den Kartenstatus. */
export function summarizeMailboxTopics (topics: MailboxTopic[]): string {
  if (topics.length === 0) {
    return ''
  }
  const active = topics.filter(t => t.enabled).length
  if (active === topics.length) {
    return 'Die Postfächer erhalten alle Themen.'
  }
  if (active === 0) {
    return 'Keine Themen gewählt – die Postfächer erhalten keine Sammel-Benachrichtigung mehr.'
  }
  return `Die Postfächer erhalten ${active} von ${topics.length} Themen.`
}
